import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect }    from 'react-redux';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Checkbox,
  Radio
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import moment from 'moment';

import {
  Breadcrumb as BreadcrumbComponent
}                        from '../../../components';

import { getCoutnryCity } from '../../../redux/actions/emailManagerActions';
import { listPostup } from '../../../redux/actions/postupActions'; 
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import { unsubscribeUser } from '../../../redux/actions/frontActions';
import { CSVLink } from "react-csv";
import languageConfig from "../../../config/languageConfig";
import { createBrowserHistory } from 'history';
import Cookies from "universal-cookie";

const history = createBrowserHistory();

const cookies = new Cookies();
let cityID = [];
let csvData = [];
let isLoading = "false";
class Unsubscription extends Component {
  constructor(props){
    super(props);
    this.state = {
      cityList: '',
      cityID: '',
      cityError: false,
      dateError: false,
      allCheck: false,
      zipcode: '',
      firstName: '',
      lastName: '',
      email: '',
      allCity: 'no',
      frequency: '',
      show: false,
      alertMessage: '',
      hover: false,
      multi_lang: 'no',
      lang: '',
      default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      post_up: 0,
      postupList: []
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }


  setDefaultLanguage = (lang) => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    siteData.default_lang = lang; 
    localStorage.setItem('siteDDBStatus', JSON.stringify(siteData));
    this.setState({
        default_lang: lang
    });
    
    let d = new Date();
    d.setTime(d.getTime() + 480 * 60 * 1000);
    cookies.set("default_lang", lang, { path: "/", expires: d });

    this.props.setLanguage(lang);
    this.props.getSiteStatus(lang); 
    this.props.getMenuList({page:1, lang: lang, cityID: siteData.default_city});
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: lang});
    }
  }

  handlePageChange = page => {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){ 
        this.setState({
          multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
        });
      }
    }

    this.setState({
      currentPage: page,
      cartTotal: 0
    });
    if(cookies.get('token')){
      //this.props.getQuantityCart({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
      this.props.getCartDetail({'userKey':cookies.get('token'), lang: (siteData && siteData.default_lang) ? siteData.default_lang : this.state.default_lang});
    }
  };

  componentWillMount(){
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: siteData.default_lang, post_up: siteData.postup});
    }
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    isLoading = "true";
    this.props.clearAlert();
    this.props.getCoutnryCity();
    this.props.listPostup({page:0}, 'postup-list/all');
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.language){
      this.setState({default_lang: nextProps.language});
    }

    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          isLoading = "false";
          this.setState({cityList: nextProps.cityList.data});
        }
    } 

    if(this.props.subscribeStatus != nextProps.subscribeStatus){
      if(nextProps.subscribeStatus){
        isLoading = "false";
        this.handleShow();
        this.props.renderAlert('success',nextProps.subscribeStatus.message);
      }
    }

    if(this.props.error !== nextProps.error){
      if(nextProps.error){
        this.props.clearAlert ();
        this.handleShow();
        this.props.renderAlert('warning',nextProps.error);
        isLoading="false";
      }
    }

    if (this.props.postupList !== nextProps.postupList) {
      if (nextProps.postupList) {
        this.setState({
          postupList: nextProps.postupList.data,
        });
        isLoading = "false";
      }
    }

  if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType});
        window.scrollTo(0, 0);
    }

  }

  handleChange = (e) => {
    if(e.target.name == 'email'){
      this.setState({emailError: false});
    }
    this.setState({[e.target.name]: e.target.value})
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleAllCheck = (e) => {
    if (e.target.checked) {
      this.setState({allCheck : true, allCity: 'yes',  cityError: false  });
    } else {
      this.setState({allCheck : false, allCity: 'no' });
    }
  }


  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0 && this.state.allCity == 'no'){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    if(!this.state.email){
      isError = true;
      this.setState({emailError: 'red'});
    }

    return isError;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    // let referredBy = cookies.get("referredBy");
    if(!isError){
      const constData = {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        email: this.state.email,
        all_city: this.state.allCity,
        city: (this.state.cityID) ? this.state.cityID : [],
        zipcode: this.state.zipcode,
        frequency: this.state.frequency,
        unsubscribe: 'no',
        lang: this.state.default_lang,
        // affiliateID: referredBy,
        post_up: this.state.post_up
      }
      isLoading = "true";
      this.props.unsubscribeUser(constData);
    }
  }

  validateEmail = (e) =>{
    let isError = false;

    if(!this.state.email){
      isError = true;
      this.setState({emailError: 'red'});
    }

    return isError;
  }

  handleSubscribe = (e) => {
    e.preventDefault();
    let isError = this.validateEmail();
    // let referredBy = cookies.get("referredBy");
    if(!isError){
      const constData = {
        email: this.state.email,
        unsubscribe: 'yes',
        frequency: this.state.frequency,
        all_city: this.state.allCity,
        city: (this.state.cityID) ? this.state.cityID : [],
      }
      isLoading = "true";
      this.props.unsubscribeUser(constData);
    }
  }

  handlePostupData = (e) => {
    if(e.target.value != 0) {
      const cityID = [e.target.value]
      this.setState({cityError: false});
      this.setState({cityID : cityID});
    }
  }

  handSubscriptionDate = (e) => {
     if (e.target.checked) {
      this.setState({startDateRangeStatus : false, startDateValue: 'all', startDateRange: ''})
     } else {
      this.setState({startDateRangeStatus : true, startDateValue: ''})
     }

     this.setState({dateError: false});
  }

    componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }

    if(siteData){
      this.setState({ fontFamilies: siteData.font_families });
    }

    if(siteData){
      this.setState({twitterPage: siteData.twitterPage,facebookPage: siteData.facebookPage, siteName: siteData.siteName, youtube_link: siteData.youtube_link, insta_link: siteData.insta_link});
      let showCityPasswordFrom = true 
      if(siteData.password_protect == 'active' && this.props.match.path != '/login' && this.props.match.path != '/register/') {
        const cityPasswordIndx = siteData.city_passwords.findIndex(x => x.cityID === siteData.default_city);
        const cityIndx = accessibleCities.findIndex(x => x.cityID === siteData.default_city);
        
        if((cityIndx >= 0 && accessibleCities[cityIndx].status == true) || cityPasswordIndx == -1 ) {
          showCityPasswordFrom = false;
        }
        this.setState({ showCityPasswordFrom: showCityPasswordFrom });
      }
      if(!(siteData.password_protect == 'active' && showCityPasswordFrom) && siteData.popup_subscrbe == 'enable' && this.props.match.path == '/' && disableSubscriptionPopup == false){
        this.setState({ showSubscriptionFrom: true });
      }      
    }

    if(this.props.themeData){
      this.setState({
        themeData: this.props.themeData
      });

      if(this.props.themeData.menu_bar){
        this.setState({
          menuBgStyles: {
            backgroundColor: this.props.themeData.menu_bar.menu_bar_color
          }
        })
      }else{
        this.setState({
          menuBgStyles: {
            backgroundColor: ''
          }
        })
      }
      if(this.props.themeData.footer){
        this.setState({
          footerBgStyles: {
            'backgroundColor': this.props.themeData.footer.footer_color,
          },
          footerTextStyles: {
            'color': this.props.themeData.footer.footer_text_color,
          },
          footer_social_link_color: {
            'color' : this.props.themeData.footer.footer_social_link_color,
          }
          
        });
      }else{
        this.setState({
          footerBgStyles: {
            'backgroundColor': '',
          },
          footerTextStyles: {
            'color': '',
          },
          footer_social_link_color: {
            'color' : '',
          }
          
        });
      }

      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }else{
        this.setState({
          button_color: '',
          mouseover_color: '',
        });
      }

    }
  }


  render() {
  return (
    <div className="container">
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form>
          <div className="panel">
              <header className="panel-heading">{languageConfig[this.state.default_lang].manage_subscripton}</header>
              {this.state.show && this.state.alertMessage !=='' &&        
                <div className="col-lg-12">
                  <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
                </div>
              }
              <div className="panel-body">
              <Row>
                  <Col md={12} xs={12}>
                    <FormGroup>
                      <Row>
                          <Col md={4} xs={4}>
                            <ControlLabel>{languageConfig[this.state.default_lang].email}:</ControlLabel>
                            <FormControl
                              type="text"
                              placeholder={languageConfig[this.state.default_lang].email_address}
                              defaultValue={this.state.email}
                              name="email"
                              onChange={this.handleChange}
                              style={{borderColor:this.state.emailError}}
                            />
                          </Col>
                      </Row>
                      {
                        (this.state.post_up === 0) ? (
                          <Row>
                            <Col md={12} xs={12}>
                              <ControlLabel>
                                {languageConfig[this.state.default_lang].cities}:{' '}
                                <span className="text-danger">
                                  {this.state.cityError ? '(Please select city.)' : ''}
                                </span>
                              </ControlLabel>
                            </Col>
                            <Col md={12} xs={12}>
                              <Checkbox value="all" onClick={this.handleAllCheck}>
                                {languageConfig[this.state.default_lang].select_all_city}
                              </Checkbox>
                            </Col>
                            <Col md={12} xs={12}>
                            {
                              (this.state.cityList) &&
                              this.state.cityList.map((data, index) => (
                                <Row>
                                  <Col md={12} xs={12}>
                                    <b>{data.cities.length != 0 ? data.country : ''}</b>
                                  </Col>
                                  <Col md={12} xs={12}>
                                    <Row>
                                      {data.cities.map((cityData, index) => (
                                        <Col md={4} xs={12}>
                                          {cityID.indexOf(JSON.stringify(cityData.cityID)) > -1 ? (
                                            // <div>check</div>
                                            <Checkbox
                                              onClick={this.handleCityData}
                                              defaultChecked={true}
                                              value={cityData.cityID}
                                            >
                                              {cityData.title}
                                            </Checkbox>
                                          ) : (
                                            <Checkbox
                                              onClick={this.handleCityData}
                                              checked={this.state.allCheck}
                                              value={cityData.cityID}
                                            >
                                              {cityData.title}
                                            </Checkbox>
                                          )}
                                        </Col>
                                      ))}
                                    </Row>
                                  </Col>
                                </Row>
                              ))
                            }
                            </Col>
                          </Row>
                        ) : (
                          <Row>
                            <Col md={12} xs={12}>
                              <ControlLabel>
                                Please select Postup:
                                <span className="text-danger">
                                  {this.state.cityError ? '(Please select postup.)' : ''}
                                </span>
                              </ControlLabel>
                              <FormControl
                                value={this.state.cityID ? this.state.cityID[0] : ''}
                                onChange={this.handlePostupData}
                                componentClass="select"
                                name="cityID"
                                placeholder="select"
                              >
                                <option value="0">Please select {cityID}</option>
                                {this.state.postupList &&
                                  this.state.postupList.map((postup, index) =>
                                    cityID.indexOf(postup.list_number) > -1 ? (
                                      <option value={postup.list_id} selected="selected">
                                        {postup.title}
                                      </option>
                                    ) : (
                                      <option value={postup.list_id}>{postup.title}</option>
                                    )
                                  )}
                              </FormControl>
                            </Col>
                          </Row>
                        )
                      }
                    </FormGroup>
                  </Col>
                  
              </Row>
              <Row>
                <Col md={12} xs={12}>
                <ControlLabel>{languageConfig[this.state.default_lang].choose_preferred}: </ControlLabel>
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'DAILY') ?
                  <Radio name="frequency" checked={true} value="DAILY">{languageConfig[this.state.default_lang].daily}</Radio>
                  :
                  <Radio name="frequency" onClick={this.handleChange} value="DAILY">{languageConfig[this.state.default_lang].daily}</Radio>
                  }
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'WEEKLY') ?
                  <Radio name="frequency" checked={ true} value="WEEKLY">{languageConfig[this.state.default_lang].weekly}</Radio>
                  :
                  <Radio name="frequency" onClick={this.handleChange} value="WEEKLY">{languageConfig[this.state.default_lang].weekly}</Radio>
                  }
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.frequency == 'TWICEINMONTH') ?
                  <Radio name="frequency" checked={ true} value="TWICEINMONTH">{languageConfig[this.state.default_lang].twice_month}</Radio>
                  :
                  <Radio name="frequency" onClick={this.handleChange} value="TWICEINMONTH">{languageConfig[this.state.default_lang].twice_month}</Radio>
                  }
                </Col>
              </Row>
              
              <Row><hr/></Row>
              <Row>
                <Col md={12} xs={12}>
                  <Button 
                  type="submit" 
                  bsStyle="success" 
                  onClick={this.handleSubmit} 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Subscribe') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                  data-id = {'Subscribe'}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  >{languageConfig[this.state.default_lang].subscribe}</Button>
                  <Button 
                  type="submit" 
                  bsStyle="danger" 
                  onClick={this.handleSubscribe} 
                  style={{backgroundColor: (this.state.hover && this.state.hoverID == "unsubscriber") ? this.state.mouseover_color : this.state.button_color}}
                  data-id = {"unsubscriber"}
                  onMouseEnter={this.hoverOn} 
                  onMouseLeave={this.hoverOff}
                  >{languageConfig[this.state.default_lang].unsubscribe}</Button>
                  <a className="btn btn-default" href="/">{languageConfig[this.state.default_lang].cancel}</a>
                </Col>
              </Row>
              </div>
          </div>
        </form>
      </div>
    </div>
  )
  }
}

const mapStateToProps = (state,ownProps) => {
    return {
      subscribeStatus: state.frontReducer.subscribeStatus,
      error: state.frontReducer.error,
      cityList:  state.emailManagerReducer.cityList,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      postupList: state.postupReducer.listPostup,
    };
};
export default compose(
  withRouter, 
  connect(mapStateToProps, {getCoutnryCity, unsubscribeUser, renderAlert, clearAlert, listPostup})
)(Unsubscription);


// WEBPACK FOOTER //
// ./src/app/views/frontend/subscription/Unsubscription.js